import { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { createPortal } from 'react-dom';
import Input from '../../../../../../components/Input/Input';
import { Button, Icon } from '../../../../../../components';
import FormLayout from '../../../../layout/FormLayout/FormLayout';
import Select from '../../../../../../components/Select/Select';
import { Icons } from '../../../../../../components/Icon/Icon';

const DistributionCountriesCreateForm = ({ selectedData, countries, onSave, onClose }: any) => {
    const [items, setItems] = useState<any[]>(
        selectedData.length
            ? selectedData
            : [
                  {
                      domicile: {},
                  },
              ],
    );

    const handleSelectChange = (index: number, prop: string) => (value: any) => {
        let tmp = [...items];
        tmp[index] = { ...tmp[index], [prop]: value?.target ? value?.target.checked : value };
        setItems(tmp);
    };

    const handleAddItem = () => {
        setItems([
            ...items,
            {
                value: uuidv4(),
                domicile: {},
                investors: false,
            },
        ]);
    };

    const handleRemoveItem = (index: number) => () => {
        const tmp = [...items];
        tmp.splice(index, 1);
        setItems(tmp);
    };

    return (
        <>
            {createPortal(
                <FormLayout
                    title={'Distribution countries'}
                    description={'Countries where the fund can be offered / marketed.'}
                    isAbsolute={true}
                    footerMain={
                        <Button
                            onClick={onSave('distributionCountries', items)}
                            disabled={!!items.find((i) => !i.domicile?.domicileId)}
                        >
                            Upload
                        </Button>
                    }
                    footerAdditional={
                        <Button
                            secondary={true}
                            outlined={true}
                            type={'button'}
                            before={<Icon icon={Icons.add} />}
                            onClick={handleAddItem}
                            minWidth={true}
                            disabled={!!items.find((i) => !i.domicile?.domicileId)}
                        >
                            Add Line
                        </Button>
                    }
                    onClose={onClose}
                    minSize={'md'}
                >
                    {items.map((item: any, index: number) => (
                        <div
                            key={index}
                            style={{
                                marginBottom: '40px',
                                gridGap: '48px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                borderBottom: '1px dashed #D6D6D6',
                            }}
                        >
                            <Select
                                style={'small'}
                                value={item.domicile.value}
                                onChange={handleSelectChange(index, 'domicile')}
                                options={countries}
                                valueKey={'domicileId'}
                                labelKey={'domicileName'}
                                extended={true}
                                placeholder={'Choose domicile'}
                                menuPlacement={'bottom'}
                                afterLabel={
                                    <button
                                        style={{
                                            minWidth: 32,
                                        }}
                                        type={'button'}
                                        onClick={handleRemoveItem(index)}
                                    >
                                        <Icon icon={Icons.closeRounded} />
                                    </button>
                                }
                            >
                                Domicile
                            </Select>

                            <div>
                                <Input
                                    type={'checkbox'}
                                    name={'investors'}
                                    checked={item.investors}
                                    onChange={handleSelectChange(index, 'investors')}
                                >
                                    Including retail investors
                                </Input>
                            </div>
                        </div>
                    ))}
                </FormLayout>,
                document && document.getElementById('formWrapper')!,
            )}
        </>
    );
};

export default DistributionCountriesCreateForm;
